import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["title"];
import { computed } from 'vue';
import Icon from "./Icon.vue";
import alerts from '../services/Alerts';
import trans from '../services/Translator';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CopyToClipboard',
    props: {
        value: {},
        discreet: { type: Boolean },
        title: {}
    },
    setup(__props) {
        const props = __props;
        const title = computed(() => {
            return trans(props.title || 'copy_to_clipboard');
        });
        function onCopy() {
            if (props.discreet) {
                alerts.info(trans('copy_to_clipboard.success_discreet'));
                return;
            }
            const value = props.value.length > 50
                ? props.value.substr(0, 50) + '…'
                : props.value;
            alerts.info(trans('copy_to_clipboard.success', { value: value }));
        }
        function onError() {
            alerts.info(trans('copy_to_clipboard.error'));
        }
        return (_ctx, _cache) => {
            const _directive_clipboard = _resolveDirective("clipboard");
            return _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                title: title.value
            }, [
                _createVNode(Icon, { name: "clipboard" })
            ], 8, _hoisted_1)), [
                [_directive_clipboard, __props.value, "copy"],
                [_directive_clipboard, onCopy, "success"],
                [_directive_clipboard, onError, "error"]
            ]);
        };
    }
});
